import React from "react"

import Report from "pages/admin/partnerConnections/Report"

/** Подключения партнёров в админке: весь поток без ограничений по ветке. */
function Index() {
	return <Report />
}

export default Index
